// extracted by mini-css-extract-plugin
module.exports = {"bar":"Bar_bar__10JBE"};